import { useSelector } from 'react-redux';
import DroppableDummySection from './DroppableDummySection';
import useEffectiveLayoutPadding from 'EmailEditorUI/hooks/styleSettings/useEffectiveLayoutPadding';
// @ts-expect-error no declarations found for module
import { LAYOUT_PADDING } from 'EmailEditorUI/utils/styleUtils';
import { getIsFileManagerOpen } from 'LayoutBuilderUI/selectors/userInterface';
import { jsx as _jsx } from "react/jsx-runtime";
const DND_SPACING = 50;
function HeaderSection({
  firstSection,
  numSections
}) {
  const {
    top: paddingTop
  } = useEffectiveLayoutPadding();
  const isFileManagerOpen = useSelector(getIsFileManagerOpen);
  // Allow at least 50px of padding on top at all times
  const paddingWitDndSpacingOffset = Math.max(DND_SPACING, paddingTop + DND_SPACING - LAYOUT_PADDING.DEFAULT_Y);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(DroppableDummySection, {
      style: {
        paddingTop: `${paddingWitDndSpacingOffset}px`
      },
      sectionForDrop: firstSection,
      sectionIndexForDrop: 0,
      numSections: numSections,
      dropAtStartOfEmail: true,
      id: "header",
      isFileManagerOpen: isFileManagerOpen
    })
  );
}
export default HeaderSection;